import Modal from 'apollo-react/components/Modal';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setStorageSpaceDialogOpen } from '../actions/DialogStatesActions';
import { useTranslation } from '../custom-hooks/useTranslation';
import { getShowStorageSpaceDialog } from '../form-designer/selectors/common.selectors';

const StorageSpaceUnavailableDialog = () => {
  const translateString = useTranslation();
  const dispatch = useDispatch();
  const showDialog = useSelector(getShowStorageSpaceDialog);

  const handleOkClick = () => {
    dispatch(setStorageSpaceDialogOpen(false));
  };

  return (
    <Modal
      open={showDialog}
      onClose={() => dispatch(setStorageSpaceDialogOpen(false))}
      title={translateString('Storage limit')}
      message={translateString(
        'There is no available space in the storage. You can delete some entities to free space.'
      )}
      buttonProps={[{ label: translateString('Ok'), color: 'primary', onClick: handleOkClick }]}
      disableBackdropClick
      disableEscapeKeyDown
    />
  );
};

export default StorageSpaceUnavailableDialog;
